import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import rest from '../axios'; // Usando o 'rest' já configurado no seu arquivo 'api.js'
import './css/comentarios.css'; // Adicione seu arquivo de estilo aqui

const SubcategoryComponent = ({ categoryId }) => {
  const [subcategories, setSubcategories] = useState([]);
  const [categories, setCategories] = useState([]); // Estado para armazenar categorias
  const [search, setSearch] = useState('');
  const [originalSubcategoria, setOriginalSubcategoria] = useState([]); // Estado para avaliações originais
  const [showAddSubcategoryModal, setShowAddSubcategoryModal] = useState(false);
  const [showEditSubcategoryModal, setShowEditSubcategoryModal] = useState(false);
  const [showDeleteSubcategoryModal, setShowDeleteSubcategoryModal] = useState(false);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [newSubcategory, setNewSubcategory] = useState({ name: '', categoryId: categoryId });
  const [editSubcategory, setEditSubcategory] = useState({ id: '', name: '', categoryId: categoryId });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch subcategories for the selected category
    rest.get(`/admin/subcategories?categoryId=${categoryId}`)
      .then((response) => {
        console.log(response?.data?.data);
        setSubcategories(response?.data?.data || []);
        setOriginalSubcategoria(response?.data?.data || []);  // Verifique se os dados são válidos
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching subcategories:', error);
        setLoading(false);
      });

    // Fetch categories and filter duplicates
    rest.get('/admin/categories')
      .then((response) => {
        console.log(response?.data?.data);
        const uniqueCategories = Array.from(new Set(response?.data?.data?.map(category => category.id)))
          .map(id => response?.data?.data?.find(category => category.id === id));
        setCategories(uniqueCategories || []);  // Filtra categorias duplicadas
      })
      .catch((error) => {
        console.error('Error fetching categories:', error);
      });
  }, [categoryId]);
  const filterTable = () => {
    if (!search) {
      setSubcategories(originalSubcategoria); // Se a pesquisa estiver vazia, restaura as avaliações
      return;
    }
    const filter = search.toLowerCase();
    const filteredSubcategories = originalSubcategoria.filter((subcategory) =>
      subcategory.subcategory_name.toLowerCase().includes(filter) ||
      subcategory.category_name.toLowerCase().includes(filter)
    );
    setSubcategories(filteredSubcategories);
  };

  const handleAddSubcategory = () => {
    const subcategoryData = {
      name: newSubcategory.name,
      categoryId: Number(newSubcategory.categoryId)
    };
    rest.post('/admin/subcategories', subcategoryData)
      .then(() => {
        setShowAddSubcategoryModal(false);
        setNewSubcategory({ name: '', categoryId: categoryId });
        // Atualize a lista de subcategories
        rest.get(`/admin/subcategories?categoryId=${categoryId}`).then((response) => {
          setSubcategories(response?.data?.data || []);
        });
      })
      .catch((error) => {
        console.error('Erro ao adicionar subcategoria:', error);
      });
  };

  const handleEditSubcategory = () => {
    rest.put(`/admin/subcategories/${editSubcategory.id}`, editSubcategory)
      .then(() => {
        setShowEditSubcategoryModal(false);
        rest.get(`/admin/subcategories?categoryId=${categoryId}`).then((response) => {
          setSubcategories(response?.data?.data || []);
        });
      })
      .catch((error) => {
        console.error('Erro ao editar subcategoria:', error);
      });
  };

  const handleDeleteSubcategory = (id) => {
    if (!id) {
      console.error('Subcategoria não selecionada ou ID inválido');
      alert('Selecione uma subcategoria válida para excluir!');
      return;
    }

    // Atualiza a lista de subcategories de forma otimista, removendo a subcategoria deletada
    setSubcategories((prevSubcategories) =>
      prevSubcategories.filter((subcategory) => subcategory.id !== id) // Verifique se 'id' é o campo correto
    );

    setLoading(true);  // Inicia o carregamento enquanto a exclusão está em andamento

    // Envia a requisição de exclusão da subcategoria
    rest.delete(`/admin/subcategories/${id}`)
      .then(() => {
        setShowDeleteSubcategoryModal(false);  // Fecha o modal de exclusão

        // Recarrega a lista de subcategories após a exclusão
        return rest.get(`/admin/subcategories?categoryId=${categoryId}`);
      })
      .then((response) => {
        // Atualiza a lista com a resposta da API
        setSubcategories(response?.data?.data || []);
      })
      .catch((error) => {
        console.error('Erro ao excluir subcategoria:', error);
        // Se ocorrer erro, reverte a remoção da lista localmente
        setSubcategories((prevSubcategories) =>
          [...prevSubcategories]  // Restaura a subcategoria excluída (caso de erro)
        );
      })
      .finally(() => {
        setLoading(false);  // Finaliza o carregamento, mesmo em caso de erro
      });
  };

  return (
    <div className="containeri">
      {/* Barra de pesquisa */}
      <div className="mb-3">
        <input
          type="text"
          id="searchInput"
          className="form-control"
          placeholder="Pesquisar subcategoria..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            filterTable();
          }}
        />
      </div>

      <h1>subcategories</h1>

      <div className="mb-3">
        <button className="btn btn-primary" onClick={() => setShowAddSubcategoryModal(true)}>
          Adicionar Subcategoria
        </button>
      </div>

      <div className="table-wrapper">
        {loading ? (
          <Spinner animation="border" variant="primary" />
        ) : (
          <table className="table mt-4" id="subcategoryTable">
            <thead>
              <tr>
                <th>Subcategoria</th>
                <th>Categoria</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {subcategories.length > 0 && subcategories.map((subcategory) => (
                <tr key={subcategory.category_id}>
                  <td>{subcategory.name}</td>
                  <td>{subcategory.category.name}</td>
                  <td className="d-flex flex-column">
                    <button
                      className="btn btn-warning mb-2"
                      onClick={() => {
                        setSelectedSubcategory(subcategory);
                        setEditSubcategory({ id: subcategory.id, name: subcategory.name, categoryId: categoryId });
                        setShowEditSubcategoryModal(true);
                      }}
                    >
                      Editar Subcategoria
                    </button>
                    <button
                      className="btn btn-danger mb-2"
                      onClick={() => {
                        setSelectedSubcategory(subcategory);
                        setShowDeleteSubcategoryModal(true);
                      }}
                    >
                      Excluir Subcategoria
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Modal Adicionar Subcategoria */}
      <Modal show={showAddSubcategoryModal} onHide={() => setShowAddSubcategoryModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Adicionar Subcategoria</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Nome da Subcategoria</Form.Label>
              <Form.Control
                type="text"
                value={newSubcategory.name}
                onChange={(e) => setNewSubcategory({ ...newSubcategory, name: e.target.value })}
              />
            </Form.Group>

            {/* Campo para selecionar a categoria */}
            <Form.Group>
              <Form.Label>Categoria</Form.Label>
              <Form.Control
                as="select"
                value={newSubcategory.categoryId}
                onChange={(e) => setNewSubcategory({ ...newSubcategory, categoryId: e.target.value })}
              >
                <option value="">Selecione a Categoria</option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAddSubcategoryModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleAddSubcategory}>
            Adicionar Subcategoria
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Editar Subcategoria */}
      <Modal show={showEditSubcategoryModal} onHide={() => setShowEditSubcategoryModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Subcategoria</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Nome da Subcategoria</Form.Label>
              <Form.Control
                type="text"
                value={editSubcategory.name}
                onChange={(e) => setEditSubcategory({ ...editSubcategory, name: e.target.value })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditSubcategoryModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleEditSubcategory}>
            Salvar Alterações
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Excluir Subcategoria */}
      <Modal show={showDeleteSubcategoryModal} onHide={() => setShowDeleteSubcategoryModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Excluir Subcategoria</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Tem certeza de que deseja excluir a subcategoria <strong>{selectedSubcategory?.name}</strong>?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteSubcategoryModal(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={() => handleDeleteSubcategory(selectedSubcategory?.id)}>
            Excluir
          </Button>

        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SubcategoryComponent;
